/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'DriverDisinfectSignIn',
    path: '/driver-disinfect/sign-in',
    component: () =>
      import(
        /* webpackChunkName: "HealthDeclaration" */ '@/views/driver-disinfect/sign-in'
      ),
    meta: { title: '司机消杀登记' },
  },
  {
    name: 'DriverReport',
    path: '/driver-report',
    component: () =>
      import(
        /* webpackChunkName: "HealthDeclaration" */ '@/views/driver-report/index'
      ),
    meta: { title: '发起报备' },
  },
  {
    name: 'DriverReportExample',
    path: '/driver-report-example',
    component: () =>
      import(
        /* webpackChunkName: "HealthDeclaration" */ '@/views/driver-report/example'
      ),
    meta: { title: '查看示例' },
  },
];
